module.exports = __webpack_public_path__ + "img/dog-walking-en.6829c5bc.svg";